import { createSlice } from "@reduxjs/toolkit";

export const icabsProductDetailListSlice = createSlice({
  name: "icabsProductDetailListSlice",
  initialState: {
    icabsProductDetailList: [],
  },
  reducers: {
    setIcabsProductDetailList: (currentSlice, action) => {
      currentSlice.icabsProductDetailList = action.payload;
    },
  },
});

export const { setIcabsProductDetailList } =
  icabsProductDetailListSlice.actions;
export const icabsProductDetailListReducer =
  icabsProductDetailListSlice.reducer;
